import React from 'react';
import Utils from 'framework7-react/utils/utils';
import Mixins from 'framework7-react/utils/mixins';
import __reactComponentDispatchEvent from 'framework7-react/runtime-helpers/react-component-dispatch-event.js';
import __reactComponentSlots from 'framework7-react/runtime-helpers/react-component-slots.js';
import __reactComponentSetProps from 'framework7-react/runtime-helpers/react-component-set-props.js';

class F7Radio extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.__reactRefs = {};

    (() => {
      Utils.bindMethods(this, ['onChange']);
    })();
  }

  onChange(event) {
    this.dispatchEvent('change', event);
  }

  render() {
    const self = this;
    const props = self.props;
    const {
      name,
      value,
      disabled,
      readonly,
      checked,
      defaultChecked,
      id,
      style,
      className,
      inputId,
      tabIndex
    } = props;
    let inputEl;
    inputEl = React.createElement('input', {
      ref: __reactNode => {
        this.__reactRefs['inputEl'] = __reactNode;
      },
      type: 'radio',
      name: name,
      value: value,
      disabled: disabled,
      readOnly: readonly,
      checked: checked,
      defaultChecked: defaultChecked,
      onChange: self.onChange,
      id: inputId
    });
    const iconEl = React.createElement('i', {
      className: 'icon-radio'
    });
    const classes = Utils.classNames(
      className,
      'radio',
      {
        disabled
      },
      Mixins.colorClasses(props)
    );
    return React.createElement(
      'div',
      {
        id: id,
        style: style,
        className: classes,
        tabIndex: tabIndex
      },
      inputEl,
      iconEl,
      this.slots['default']
    );
  }

  get slots() {
    return __reactComponentSlots(this.props);
  }

  dispatchEvent(events, ...args) {
    return __reactComponentDispatchEvent(this, events, ...args);
  }

  get refs() {
    return this.__reactRefs;
  }

  set refs(refs) {}
}

__reactComponentSetProps(
  F7Radio,
  Object.assign(
    {
      id: [String, Number],
      inputId: [String, Number],
      className: String,
      style: Object,
      checked: Boolean,
      name: [Number, String],
      value: [Number, String, Boolean],
      disabled: Boolean,
      readonly: Boolean,
      defaultChecked: Boolean,
      tabIndex: Number
    },
    Mixins.colorProps
  )
);

F7Radio.displayName = 'f7-radio';
export default F7Radio;
